import { gql } from "@apollo/client";

export const MODELS_NAME = gql`
    query UsedInventoryData {
        getUsedModels {
            name
            __typename
        }
    }
`;